@if (!imageBase64) {
    <div class="placeholder"></div>
}
@if (imageBase64 && imageUrl) {
    <div class="container image"
         [ngClass]="{
         'with-canvas': showCanvas,
         'without-canvas': !showCanvas,
         'checkered': showCanvas && canvasType === CanvasType.CHECKERED,
         'dark': showCanvas && canvasType === CanvasType.DARK,
         'light': showCanvas && canvasType === CanvasType.LIGHT
     }">
        <img [src]="imageUrl">
    </div>
}
